module.exports = __webpack_public_path__ + "static/media/11.3e3d1434.jpg";